import { TabletopCanvasInputMode } from "./TabletopCanvasInputMode";

export enum TabletopCanvasInputDomain {
    ENVIRONMENT,
    NAVIGATION,
    TERRAIN,
    TOKENS,
}

export function fromTabletopCanvasInputMode(
    mode: TabletopCanvasInputMode,
): TabletopCanvasInputDomain {
    switch (mode) {
        case TabletopCanvasInputMode.DRAW_TERRAIN:
        case TabletopCanvasInputMode.MANIPULATE_TERRAIN:
            return TabletopCanvasInputDomain.TERRAIN;
        case TabletopCanvasInputMode.CREATE_TOKEN:
        case TabletopCanvasInputMode.MANIPULATE_TOKEN:
            return TabletopCanvasInputDomain.TOKENS;
    }

    return TabletopCanvasInputDomain.NAVIGATION;
}
